var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userLearnPortalLink)?_c('v-list-item',{attrs:{"target":"_blank","href":_vm.userLearnPortalLink}},[_c('v-list-item-icon',[_c('icon-base',{attrs:{"fontIcon":"","icon":"school"}})],1),_c('v-list-item-title',{staticClass:"pr-2"},[_vm._v(" Learn Portal ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }